import _global3 from "../internals/global";
import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var _global2 = _global3;
var uncurryThis = _functionUncurryThis;
exports = function (CONSTRUCTOR, METHOD) {
  return uncurryThis(_global2[CONSTRUCTOR].prototype[METHOD]);
};
export default exports;